import React from 'react';
import QuestionManagementComponent from '../../../components/admin/coffee-chat/QuestionManagementComponent';

const QuestionManagement: React.FC = () => {
  return <QuestionManagementComponent />;
};

export default QuestionManagement;
